export class AerovaleRespuesta {    
    id: string;
    prefijo: number;
    numeroAerovale: number;
    estado: string;
    warnings: string[];
    ciudadAerovaleId : string;
}
